module.exports = __webpack_public_path__ + "img/rearfoot_strike.ba3c348a.svg";